// HIER KOMEN ALLE NIEUWE PACKAGES/OUDE BOWER PACKAGES
var $ = require('jquery');
require('foundation-sites');
require('magnific-popup');
